import { BLOG_ROUTE } from "constants/route.const";

export function generateBlogUrl(blogFrontmatter) {
  return encodeURI(
    BLOG_ROUTE +
      '/' +
      encodeURIComponent(
        replaceAll(replaceAll(blogFrontmatter.title, ',', '-'), ' ', '-')
      )
  );
}

const blockedChars = ['%', ':', '@', '?', '^', '&', '#', '--', '[', ']'];
function replaceAll(str, replaceKey, replaceWith) {
  const s = str
    .replace(/ *\([^)]*\) */g, '')
    .split(replaceKey)
    .map(e => e.trim())
    .filter(e => e)
    .filter(e => e !== replaceWith)
    .map(e => {
      return blockedChars.reduce((newStr, key) => {
        return newStr.trim().split(key).join('');
      }, e);
    })
    .filter(e => e)
    .join(replaceWith)
    .toLocaleLowerCase();

  return s;
}
